import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useLocalObservable } from "mobx-react-lite";
import { myCompanyIntro } from "../services/CompanyIntroService";
import StoreAction from "./StoreAction";


// const initialState = {
//   problem: "",
//   solution: "",
//   now: "",
//   slogan: "",
//   feature: "",
//   advantage: "",
//   label1: "",
//   label2: "",
//   label1_percentage: "",
//   label2_percentage: "",
//   label1_illustration: "",
//   label2_illustration: "",
//   company1: "",
//   company2: "",
//   company3: "",
//   company1_illustration: "",
//   company2_illustration: "",
//   company3_illustration: "",
//   com_mode: "",
//   financial_state: "",
//   finstate1_year: "",
//   finstate2_year: "",
//   teamdata: "",
// };

const initialState = {
  videotitle: "",
  companyname: "",
  field: "",
  slogan: "",
  intro: "",
  advantage: "",
  unique: "",
  market: "",
  marketvalue: "",
  businessmodel: "",
  teamintro: "",
  growth: "",
  outputvalue: "",
  firstcomp: "",
  secondcomp: "",
  thirdcomp: "",
  financepredict: "",
  assetone: "",
  assettwo: "",
  assetthree: "",
  assetfour: "",
  assetfive: "",
  moneyone: "",
  moneytwo: "",
  moneythree: "",
  moneyfour: "",
  moneyfive: "",
};

const CompanyIntroStore = () => {
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialState,
    ...StoreAction(initialState),
  }));

  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    console.log("company intro store load");
    if (user) {
      myCompanyIntro().then((value) => {
        console.log(value);
        if (value) {
          // store.updateData("problem", value.problem);
          // store.updateData("solution", value.solution);
          // store.updateData("now", value.now);
          // store.updateData("slogan", value.slogan);
          // store.updateData("feature", value.feature);
          // store.updateData("advantage", value.advantage);
          // store.updateData("label1", value.label1);
          // store.updateData("label2", value.label2);
          // store.updateData("label1_percentage", value.label1_percentage);
          // store.updateData("label2_percentage", value.label2_percentage);
          // store.updateData("label1_illustration", value.label1_illustration);
          // store.updateData("label2_illustration", value.label2_illustration);
          // store.updateData("company1", value.company1);
          // store.updateData("company2", value.company2);
          // store.updateData("company3", value.company3);
          // store.updateData("company1_illustration", value.company1_illustration);
          // store.updateData("company2_illustration", value.company2_illustration);
          // store.updateData("company3_illustration", value.company3_illustration);
          // store.updateData("com_mode", value.com_mode);
          // store.updateData("financial_state", value.financial_state);
          // store.updateData("finstate1_year", value.finstate1_year1 || "");
          // store.updateData("finstate2_year", value.finstate1_year2 || "");
          // store.updateData("teamdata", value.teamdata);
          store.updateData("videotitle", value.videotitle);
          store.updateData("companyname", value.companyname);
          store.updateData("field", value.field || "");
          store.updateData("slogan", value.slogan || "");
          store.updateData("intro", value.intro || "");
          store.updateData("advantage", value.advantage || "");
          store.updateData("unique", value.unique || "");
          store.updateData("market", value.market || "");
          store.updateData("marketvalue", value.marketvalue || "");
          store.updateData("businessmodel", value.businessmodel || "");
          store.updateData("teamintro", value.teamintro || "");
          store.updateData("growth", value.growth || "");
          store.updateData("outputvalue", value.outputvalue || "");
          store.updateData("firstcomp", value.firstcomp || "");
          store.updateData("secondcomp", value.secondcomp || "");
          store.updateData("thirdcomp", value.thirdcomp || "");
          store.updateData("financepredict", value.company2_illustration || "");
          store.updateData("assetone", value.assetone || "");
          store.updateData("assettwo", value.assettwo || "");
          store.updateData("assetthree", value.assetthree);
          store.updateData("assetfour", value.assetfour || "");
          store.updateData("assetfive", value.assetfive || "");
          store.updateData("moneyone", value.moneyone || "");
          store.updateData("moneytwo", value.moneytwo || "");
          store.updateData("moneythree", value.moneythree || "");
          store.updateData("moneyfour", value.moneyfour || "");
          store.updateData("moneyfive", value.moneyfive || "");
        }
      });
    }
  });
  return store;
};

export default CompanyIntroStore;
